/* unplugin-vue-components disabled */import script from "./selectData.vue?vue&type=script&setup=true&lang=js"
export * from "./selectData.vue?vue&type=script&setup=true&lang=js"

import "./selectData.vue?vue&type=style&index=0&id=560f6988&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-560f6988"]])

export default __exports__